export default __webpack_public_path__ + "static/media/icon_membership.a55893bc.svg";